import { createSelector } from 'reselect';

import { RootState } from '../types';

export const flyingChipsSelector = (state: RootState) => state.flyingChips.chips;

export const hasFlyingChipAnimationToBetSpot = createSelector(
  [ flyingChipsSelector, (state, betType) => betType ],
  (flyingChips, betType) => flyingChips.some(
    (chip) => chip.betType === betType && chip.direction === 'BET_SPOT'
  )
);

export const hasFlyingChipAnimationToChipSelector = createSelector(
  [ flyingChipsSelector, (state, betType) => betType ],
  (flyingChips, betType) => flyingChips.some(
    (chip) => chip.betType === betType && chip.direction === 'CHIP_SELECTOR'
  )
);
